<template>
  <div class="select">
    <select v-on:change="$emit(eventName, $event.target.value)">
      <option v-if="$store.selectedAppLanguage == 'ar'" :value="10">{{ $t('sessions') + ' ' + 10 + ' ' + $t('last') }}
      </option>
      <option v-else :value="10">{{ $t('last') + ' ' + 10 + ' ' + $t('sessions') }}</option>
      <option v-if="$store.selectedAppLanguage == 'ar'" :value="25" selected>{{ $t('sessions') + ' ' + 25 + ' ' +
        $t('last') }}</option>
      <option v-else :value="25" selected>{{ $t('last') + ' ' + 25 + ' ' + $t('sessions') }}</option>
      <option v-if="$store.selectedAppLanguage == 'ar'" :value="50">{{ $t('sessions') + ' ' + 50 + ' ' + $t('last') }}
      </option>
      <option v-else :value="50">{{ $t('last') + ' ' + 50 + ' ' + $t('sessions') }}</option>
      <option :value="51">{{ $t('all') + ' ' + ' ' + $t('sessions') }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'SelectList',
  props: ['eventName'],
};
</script>

<style>
select {
  font-size: 16px;
  transform-origin: right;
  transform: scale(0.9);
  color: #5a5a5a;
  border-radius: 7px;
  /* margin-right: 20%; */
  padding: 5px 29px 5px 3px;
  /* background-color: #ffffff; */
  font-weight: bolder;
  border-color: #707070;
  -webkit-appearance: none;
  appearance: none;
  /* padding-left: 3px; */
  background: url('../../assets/arrow.png') no-repeat -9px;
  background-position: right 4px center;
}

[dir="rtl"] select {
  padding: 5px 5px 5px 29px;
  transform-origin: left;
  background: url('../../assets/arrow.png') no-repeat -140px;
}
</style>
